import { KYMW0A00Model } from '../kymw0a00.model';
import { SelectPublishVoiceModel } from '../vo/select-publish-voice-model';
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

/**
 * 組合員の声掲載履歴検索をするサービス
 *
 * @export GetPublishVoiceDataService
 * @class GetPublishVoiceDataService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class GetPublishVoiceDataService extends PlessJsonResponderSub<any> {
  private model: KYMW0A00Model = null;
  private vo: SelectPublishVoiceModel;
  private successFunc: Function;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof GetPublishVoiceDataService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      parameter: {
        CoopCode: this.vo.coopCode,
        OrderCode: this.vo.orderCode,
        Pcode: this.vo.selectPcode,
        OrderGoodsFlg: this.vo.orderGoodsFlg,
        ReceiptSOrderCode: this.vo.receiptSOrderCode,
        OrderNum6Digits: this.vo.orderNum6Digits,
        ItemCode: this.vo.itemCode
      }
    });
  }

  /**
   * API呼び出し
   *
   * @param model KYMW0A00Model
   * @memberof GetPublishVoiceDataService
   */
  execute(model: KYMW0A00Model, vo: SelectPublishVoiceModel, successFunc: Function): void {
    this.model = model;
    this.vo = vo;
    this.successFunc = successFunc;
    this.send('getPublishVoiceData', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof GetPublishVoiceDataService
   */
  success(data: any): void {
    // サーバからの結果を元に、選択Ｐコードに紐付く受付番号を更新する
    this.model.getPublishVoiceData(data);
    // 後続処理を実行
    this.successFunc();
  }
}
